<template>
  <div>
    <VTextField
      v-model="data.key"
      :label="$t('deviceAnalysisKeys.key')"
      :disabled="isEdition"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.name[selectedLang]"
      :label="`${$t('deviceAnalysisKeys.name')}(${selectedLang})`"
      :rules="{ max: 200 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.unit[selectedLang]"
      :label="`${$t('deviceAnalysisKeys.unit')}(${selectedLang})`"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VAutocomplete
      v-model="data.deviceTypes"
      :items="deviceTypes"
      :label="$t('deviceAnalysisKeys.deviceTypes')"
      itemText="type"
      :multiple="true"
      outlined
      @change="updateData"
    />
  </div>
</template>


<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'DeviceAnalysisKeyForm',
    components: {
        VTextField,
        VAutocomplete,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                key: '',
                unit: {},
                name: {},
                deviceTypes: [],
            },
            deviceTypes: [],
            queryParams: {
                page: 1,
                perpage: 25,
            },
        };
    },
    computed: {
        ...mapGetters(['userLang', 'selectedLang']),

    },
    async created() {
        if (this.isEdition) {
            this.data = {
                ...this.item,
                deviceTypes: this.item.deviceTypes.length ? this.item.deviceTypes.map(({ _id: id, type }) => ({ id, type })) : [],
                name: this.item.name || {},
            };
        }
        const { data } = await this.$rq.getDevices({ ...this.queryParams, pagination: false });
        this.deviceTypes = data.deviceTypes;
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};

</script>
